module.exports = __webpack_public_path__ + "img/chadle_adv_02.7bd6f0e3.png";